import { normalizeDniSlashes } from '../../modules/utils/normalizeForeignDni'
import routes from '../../config/settings/routes'
import { makeActionCreator } from '../../config/store/utils'
import { DNI_PARAM } from '../../config/settings/constant'

export const FIX_BROKEN_ROUTE = 'FIX_BROKEN_ROUTE'
export const FIX_BROKEN_ROUTE_SUCCESS = 'FIX_BROKEN_ROUTE_SUCCESS'
export const FIX_BROKEN_ROUTE_ERROR = 'FIX_BROKEN_ROUTE_ERROR'

export const fixBrokenRoute = makeActionCreator(FIX_BROKEN_ROUTE)
export const fixBrokenRouteSuccess = makeActionCreator(FIX_BROKEN_ROUTE_SUCCESS, 'payload')
export const fixBrokenRouteError = makeActionCreator(FIX_BROKEN_ROUTE_ERROR, 'payload')

export const fixBrokenRouteThunk = pathname => dispatch => {
  const segments = pathname.split('/').filter(Boolean)

  if (segments.length >= 2) {
    const [base, ...rest] = segments
    const encodedRut = normalizeDniSlashes(rest.join('/'))

    let redirectTo = null

    if (segments.length === 2) {
      const sellerCardEncoded = normalizeDniSlashes(segments.join('/'))
      redirectTo = routes.sellerCard.replace(DNI_PARAM, sellerCardEncoded)
    }

    switch (base) {
      case 'habilidad':
        redirectTo = routes.ability.replace(DNI_PARAM, encodedRut)
        break
      case 'comportamiento':
        redirectTo = routes.contractualBehavior.replace(DNI_PARAM, encodedRut)
        break
      case 'documentos':
        redirectTo = routes.documents.replace(DNI_PARAM, encodedRut)
        break
      case 'informacion-general':
        redirectTo = routes.generalInformation.replace(DNI_PARAM, encodedRut)
        break
      case 'certificado':
        if (rest[0] !== 'inscripcion') {
          redirectTo = routes.enrollmentCertificateBySeller.replace(DNI_PARAM, encodedRut)
        }
        break
      case 'contrato':
        if (rest[0] === 'historico') {
          redirectTo = routes.historicalContract.replace(DNI_PARAM, normalizeDniSlashes(rest.slice(1).join('/')))
        }
        break
      case 'sancion':
        if (rest[0] === 'historico') {
          redirectTo = routes.historicalSanctionsList.replace(DNI_PARAM, normalizeDniSlashes(rest.slice(1).join('/')))
        } else if (rest.length >= 2) {
          const id = rest[rest.length - 1]
          const rut = rest.slice(0, -1).join('/')
          const encodedRut = normalizeDniSlashes(rut)

          redirectTo = routes.sanctionDetails.replace(DNI_PARAM, encodedRut).replace(':id', id)
        } else {
          redirectTo = routes.registerSanction.replace(DNI_PARAM, encodedRut)
        }
        break
      case 'idoneidad':
        redirectTo = routes.suitability.replace(DNI_PARAM, encodedRut)
        break
      case 'uniones-temporales':
        redirectTo = routes.temporaryUnions.replace(DNI_PARAM, encodedRut)
        break
      case 'registro-obras':
        redirectTo = routes.workRegister.replace(DNI_PARAM, encodedRut)
        break
      case 'ficha':
        redirectTo = routes.sellerCard.replace(DNI_PARAM, encodedRut)
        break
      default:
        break
    }

    if (redirectTo) {
      dispatch(fixBrokenRouteSuccess(redirectTo))
      return redirectTo
    }
  }

  dispatch(fixBrokenRouteError(null))
  return null
}
